import React, { useEffect, useRef, useState } from 'react'
import { clickOutside } from '../../utils';

export const InputsPopup = ({className = '', tabIndex, noPadding = false, minSizes = {}, sizes = {}, children, placeholder}) => {
  
  const [isOpened, setOpen] = useState(false);
  const popupRef = useRef(null);
  useEffect(() => {
    if (!isOpened) return;
    const clickOutsideHandler = (evt) => clickOutside(evt, popupRef, setOpen);
    document.addEventListener('mousedown', clickOutsideHandler);
    document.addEventListener('contextmenu', clickOutsideHandler);
    return () => {
      document.removeEventListener('mousedown', clickOutsideHandler)
      document.removeEventListener('contextmenu', clickOutsideHandler)
    };
  }, [isOpened]);


    return (
      <div className={`inputs-popup-wrapper ${isOpened ? 'opened' : ''} ${className}`} tabIndex={tabIndex} ref={popupRef} onClick={() => setOpen(true)}>{isOpened ? '' : placeholder}
        <div className={`inputs-popup dark-theme-bg0`} style={{...minSizes, ...sizes, ...(noPadding ? {padding: '0'} : {})}}>
            {children}
        </div>
      </div>
    );
}
